import { Injectable } from '@angular/core';

/*
* Ebben a serviceben vannak letárolva név szerint az előre elkészített cella templatek, így globálisan elérhetők a servicen keresztül
*/
@Injectable({
  providedIn: 'root'
})
export class ColumnTemplateService {

  templates: Object = {};
  constructor() {
  }

  templateExist(name): boolean {
    return this.templates.hasOwnProperty(name);
  }
}
